/* eslint-disable react/no-unescaped-entities */
import React, { useCallback,useEffect,useState,useRef } from "react";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import Tappable from 'react-tappable/lib/Tappable'
import {trigger} from "../../../utils/events"
import albumOptionsEvents from "./album_options_events";
import {unSelectedAlbumsData} from "../meta/selectors";
import './prepare_individual_album.scss';
import { hideDropdownMenu, toggleElementById } from "../../../utils/common_utils"

/* global photoOrg */
const PrepareIndividualAlbum = function ({albumModel, accessType,foundRef, setRef, container_key, albumThumnailSize,inlineIngestionFlow, currentPageno}) {
    let albumId = albumModel.albumId || albumModel.id;
    const [isHovering, setIsHovering] = useState(photoOrg.Util.isTouchDevice()? true :false);
    const [isAlbumSelected, setAlbumSelected] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState(0);
    const menuItemsRef = useRef([]);
    const menuRef = useRef([]);
    
    const selectedAlbumDataRes = useSelector(state => state.album.allAlbumPicInfo.selectedAlbums?.data[albumId]);
    const deletedAlbumArr = useSelector(state => state.album.deletedAlbumsArr);
    const unSelectedAlbumsDataRes = useSelector(unSelectedAlbumsData);
    
    const ref = useRef(null);
    const settingsIconRef = useRef(null);
    const deletedAlbumIdsInRef = useRef(0);
    const selectedAlbumDataResInRef = useRef(null);

    
    const hideAllIconPallets = useCallback(()=>{
        try{
            if(ref.current.getElementsByClassName("iconspallet")[0].style.visibility === "hidden"){
                return;
            }else{
                console.log("hiding all icon pallets");
                setIsHovering(false);
            }
        }catch(e){
            //setIsHovering(false);
        }
    },[])

    useEffect(() =>{
        //cleanup function to delete the assets if present in tray
        return () => {
            /** 
             * capturing the deletedAlbumId value from slices in pending state (consdiered as deleted album) and
             * rejected state (removing as non-deleted album).
             * NOTE : updating deletedAlbumArr state in pending xhr status, 
             * as deletedAlbumIdsInRef.current useEffect is not updating if modified deletedAlbumArr state in fulfilled xhr status.
             * This issue is due to filtering(removal) of the album from selectedAlbumDataRes in fulfilled xhr status.
             * so only cleanup function is executed
             */
            const sortCriteria = photoOrg.history.historyState.sc;
            if(sortCriteria === "caption"){
             albumId = "" + albumId ;
            }
            if(deletedAlbumIdsInRef.current.includes(albumId)){
                const selectedAlbumDataRes = selectedAlbumDataResInRef.current
                if(selectedAlbumDataRes && selectedAlbumDataRes.entities){
                    albumOptionsEvents.addImagesToTray(selectedAlbumDataRes.entities, albumId, false/** remove assets from tray if false */);
                }
                toggleElementById("loadingBar", "none");
            }
            selectedAlbumDataResInRef.current = "";
            deletedAlbumIdsInRef.current = "";
        }        
    },[])

    //gets value from slices, selectedAlbumDataResInRef.current is used inside cleanup function as useSelector is not accessbile
    useEffect(() => { 
        selectedAlbumDataResInRef.current = selectedAlbumDataRes;
    }, [selectedAlbumDataRes]);
    
    //gets value from slices, deletedAlbumIdsInRef.current is used inside cleanup function
    useEffect(() => { 
        deletedAlbumIdsInRef.current = deletedAlbumArr;
    }, [deletedAlbumArr]);

    //to hold the latest found album and then result in scrolling once loaded the response
    useEffect(()=>{
        if(foundRef){
            setRef(ref);
        }
        if(!photoOrg.photoLib.config.loadAsPhotoPicker){
            document.removeEventListener("hideAllIconPallets",hideAllIconPallets);
            document.addEventListener("hideAllIconPallets", hideAllIconPallets);
        }
    },[])
    
    useEffect(() =>{
        if(unSelectedAlbumsDataRes &&  unSelectedAlbumsDataRes.length > 0){
            albumOptionsEvents.addImagesToTray(unSelectedAlbumsDataRes, albumId, false/** remove assets from tray if false */);
        }
    },[unSelectedAlbumsDataRes])

    useEffect(() =>{
        if(selectedAlbumDataRes && Object.keys(selectedAlbumDataRes).length > 0){
            albumOptionsEvents.addImagesToTray(selectedAlbumDataRes.entities, albumId, true);
            toggleElementById("loadingBar", "none");
            setAlbumSelected(true)
        }
    },[selectedAlbumDataRes])

    useEffect(() => {
        if (menuItemsRef.current[focusedIndex] && !photoOrg.Util.isTouchDevice()) {
          menuItemsRef.current[focusedIndex].focus();
          menuItemsRef.current[focusedIndex].setAttribute('tabindex', 0);
          menuRef.current.setAttribute('aria-activedescendant', menuItemsRef.current[focusedIndex].getAttribute('id'));
        }
    }, [focusedIndex])

    
    const isElementVisible = function( el ) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
      
        while(el.offsetParent) {
          el = el.offsetParent;
          top += el.offsetTop;
          left += el.offsetLeft;
        }
      
        return (
          top >= window.pageYOffset &&
          left >= window.pageXOffset &&
          (top + height) <= (window.pageYOffset + window.innerHeight) &&
          (left + width) <= (window.pageXOffset + window.innerWidth)
        );
    };

    const handleAlbumOptionAccessibility = (event) => {
        if (event.key === 'ArrowLeft') {
          setFocusedIndex((prevIndex) => {
            menuItemsRef.current[prevIndex].setAttribute('tabindex', -1);
            if(prevIndex > 0){
                return prevIndex - 1;
            }
            return menuItemsRef.current.length - 1;
          });
        } else if (event.key === 'ArrowRight') {
          setFocusedIndex((prevIndex) => {
            menuItemsRef.current[prevIndex].setAttribute('tabindex', -1);
            if(prevIndex < menuItemsRef.current.length - 1){
                return prevIndex + 1;
            }
            return 0;
          });
        }
    };
    
    const handleMouseOver = useCallback(() => {
        if(!photoOrg.Util.isTouchDevice()){
            if(ref.current.getElementsByClassName("iconspallet")[0].style.visibility === "visible"){
                if(!photoOrg.photoLib.config.loadAsPhotoPicker){
                    hideDropdownMenu();
                }
            }
            
            if(!photoOrg.photoLib.config.loadAsPhotoPicker){
                //TODO: remove the Temp click for fixing the dropdown to open on single click.
                document.body.click();
                trigger("hideAllIconPallets",{});
            }
            setTimeout(() => {
                setIsHovering(true); 
            }, 150);
            
        }    
    },[]);
    const handleMouseOut = useCallback(() => {
        if(!photoOrg.Util.isTouchDevice()){
            if(photoOrg.photoLib.config.loadAsPhotoPicker || !isElementVisible(document.getElementById('ralb-gearicon'))){
                setIsHovering(false);
            }
        }
    },[]);

    
    const redirectTOPrints = (event) => {
        event.stopPropagation();
        const isTouchDevice = event.type == "touchstart";
        albumOptionsEvents.redirectToPrints(albumId,isTouchDevice);
    }  
   
    const selectOrDeselectAlbum = (event, deSelectAlbum) =>{
        try{
            /**
             *  combintation of 
             *  "touchend" listener can call evt.preventDefault() and your
             *  "mouseup" listeners won't fire because they come later in the chain.
             * 
             * touchstart and mouseDown combination is not working meaning both listeners are working in touch devices
             */
            event.preventDefault();
            event.stopPropagation();
            const activeDropdown = settingsIconRef.current;
            if(deSelectAlbum && selectedAlbumDataRes && Object.keys(selectedAlbumDataRes).length > 0){
                toggleElementById("loadingBar", "block");
                albumOptionsEvents.selectDeselect(albumId, selectedAlbumDataRes, setAlbumSelected, deSelectAlbum);
                if (activeDropdown) {
                    activeDropdown.classList.remove('menu_active');
                }                
            }else if(deSelectAlbum && !selectedAlbumDataRes){
                albumOptionsEvents.selectDeselect(albumId, null, null, deSelectAlbum);
            }else{
                toggleElementById("loadingBar", "block");
                albumOptionsEvents.selectDeselect(albumId);
            }
        }catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:selectOrDeselectAlbum:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    }

    const loadSingleAlbum = (event) =>{
        try{
           //return if key code not a 'enter' key code
           if(event.keyCode && event.keyCode !== 13 || event.target.closest('.iconspallet')){
            return;
            }
            photoOrg.cLog("Loading single album view.....");
            const sortCriteria = photoOrg.history.historyState.sc;
            const itemSecDiv = ref.current.getElementsByClassName("item-sec-div")[0];
            photoOrg.saveAlbumDetails = {
                saveAlbumId: albumId,
                pageNo: itemSecDiv.getAttribute("pageno"),
                date: itemSecDiv.getAttribute("presentmonth"),
                response: selectedAlbumDataRes
                
            };
            if(sortCriteria == "caption"){
                photoOrg.saveAlbumDetails.key = itemSecDiv.closest('li').id;
            }

            albumOptionsEvents.loadSingleAlbumView(event, albumId);
            // // Get the cart count (localCartValue) for the user
            // const printsProjectId = photoOrg.storage.getValueFromStorage(photoOrg.config.account_id + '_printsProjectId', { useLocalStorage: true });
            // const cartCountKey = photoOrg.config.account_id + "_" + printsProjectId + "_noOfPrintsInCart";
            // const localCartValue = photoOrg.storage.getValueFromStorage(cartCountKey, { useLocalStorage: true });

            // // After loading the album, call redirectTOPrints to handle photo limit, cart management, and redirection
            // const assetCollection = photoOrg.savPage && photoOrg.savPage.singleAlbumView.collection.models;
            
            // // Pass the localCartValue to the redirectTOPrints function
            // redirectTOPrints(event, localCartValue);
        }catch (e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:loadSingleAlbum:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    }

    const handleDropdownClick = (e) =>{
        try{
            e.preventDefault();
            e.stopPropagation();
            photoOrg.Util.trackLinksAndButtons('Albums_ToolIcon', 'albumsPage');
            document.querySelectorAll(".menu_active").forEach(el => el.classList.remove('menu_active'))
            e.currentTarget.classList.add('menu_active')
            const currentAlbumGearIcon = e.currentTarget.getBoundingClientRect()
            const fDropdown= document.getElementById("ralb-gearicon");
            fDropdown.style.display = "none";
            fDropdown.style.top = currentAlbumGearIcon.top + e.currentTarget.clientHeight + "px";
            fDropdown.style.left = currentAlbumGearIcon.left + "px";
            fDropdown.style.display = "block";
            const keyCode = e.keyCode;
            fDropdown.classList.add("open");
            trigger("rsetToolTip",{setToolTip: e.target.id, keyCode})
            }catch(e) {
            photoOrg.clientLogger.error({description: "LIBRARY:albums_view:handleDropdownClick:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
        }
    }
    
    const showAlbumHoverSection = () => {
        document.querySelectorAll(".photo-Org .iconspallet").forEach(el => el.style.visibility = "hidden");
        ref.current.getElementsByClassName("iconspallet")[0].style.visibility = "visible";
    };

    try { // get thumnail image and album id
        let thumbData = null,albumImgUrl="";
        if(!albumModel.albumImgUrl){
            
            if(albumModel.preparetnlUrl){
                albumImgUrl = photoOrg.config.thumbnailServiceUrl+"thumbnail/"+albumModel.firstAssetId.thumbnailEncryption+"?height="+albumThumnailSize;
            }else{
                if(!inlineIngestionFlow){
                    thumbData = photoOrg.photoLib.getThumbDataFromCollection(albumModel, albumThumnailSize);
                    albumImgUrl = thumbData.thumb;
                    albumModel.aId =  thumbData.aId || albumModel.id;
                }else{
                    albumImgUrl = albumModel.url;
                    albumModel.aId =  albumModel.albumId;
                }
            } 
            //photoOrg.projectTrayView && photoOrg.projectTrayView.setFirstImageAssetRef(albumModel);
            albumModel.albumImgUrl = albumImgUrl;
        }

        albumModel.id = albumModel.albumId || albumModel.id;

        albumModel.container_key = container_key;
        //albumModel.caption is for alphabetical sort
        albumModel.caption = albumModel.name || albumModel.caption || photoOrg.assetUtils.getValue(albumModel.userTags, 'caption');
        if (albumModel.caption === undefined) {
            albumModel.caption = "";
        }
        //albumModel.description is for alphabetical sort
        albumModel.description = albumModel.description || photoOrg.assetUtils.getValue(albumModel.userTags, 'description');

        let isShared = false;
        let customSortEnabled = false;
        albumModel.systemTags.forEach(function (obj) {
            if (obj.key == "Share" && obj.value === "Private") {
                isShared = true;
            }
            if (obj.key == "customOrder" && obj.value === "true") {
                customSortEnabled = true;
            }
        });
        if(albumModel.type == "shared"){
            isShared = true;
        }
        //checking for alpha sort albummodel
        if(albumModel.share && albumModel.share === "Private"){
            isShared = true;    
        }
        //checking for alpha sort albummodel
        if(albumModel.customOrder && albumModel.customOrder === "true"){
            customSortEnabled = true;
        }

        albumModel.isShared = isShared;

        albumModel.customSortEnabled = customSortEnabled;
        let originalCaption = albumModel.caption;
        let originalDescription = albumModel.description

        if (albumModel.caption.length > 25) {
            albumModel.caption = albumModel.caption.substr(0, 25).replace(/ +/g, ' ') + '...'
        }

        albumModel.o_caption = originalCaption;
        albumModel.o_description = originalDescription;
        albumModel.albumIconlongPress = false;            
        //Items text is used for google album and photos text is used for all other images.
        let isGoogleAlbum = photoOrg.Util.isInlineIngAndGoogleSource(albumModel.source);
        let imagesCount = albumModel.imagesCount ? albumModel.imagesCount : (albumModel.assetIdList ? albumModel.assetIdList.length : 0)
        let assetsText = photoOrg.photoLib.getAssetText(imagesCount,isGoogleAlbum);
        let content = "";
        //if imageCount is not available, then we are not showing the album count information
        if(imagesCount){
            content = imagesCount + " " + assetsText;
        }
        let imageText = " " + assetsText;

        let sharedByMe = false;
        let ownerName = photoOrg.config.someone;
        let sharedWithName = photoOrg.config.someone;
        let sharedWithAllNames = ""

        let sharedWithDetails = photoOrg.photoLib.getSharedToNames(albumModel);
        if(sharedWithDetails.sharedWithName){
            sharedWithName = sharedWithDetails.sharedWithName;
        }

        if(sharedWithDetails.sharedWithAllNames){
            sharedWithAllNames = sharedWithDetails.sharedWithAllNames;
        }

        if(sharedWithDetails.sharedByMe){
            sharedByMe= sharedWithDetails.sharedByMe;
        }

        if (albumModel.ownerInfo) {
            ownerName = albumModel.ownerInfo.firstName;
        }

        if (!photoOrg.config.account_id)
            photoOrg.clientLogger.warn({description: "Account Id is mandatory Filed", accountId: photoOrg.config.account_id});

        let shareIcon = "inline-block"
        if (accessType === photoOrg.photoLib.accessType.sharedWithMe) { //TODO: check this
            shareIcon = "none";
        }
        let albumSelectedInPicker = false;
         let albumSelected ;
         
         albumSelected = photoOrg.selectionManager.isAlbumSelectedById(`${albumModel.id}`);
        try {              
            if(photoOrg.photoLib.config.loadAsPhotoPicker){
                albumSelectedInPicker = photoOrg.selectionManager.isAlbumSelectedInpickerById(`${albumModel.id}`);
            }
        } catch (e) {
            console.log('some error with photoorg.photolib.selectedalbums object')
        }
        let pageNo = currentPageno;
        let presentMonth = "";
        if (!photoOrg.history.historyState.sc) {
            let date = new Date(albumModel.updateDate);
            presentMonth = date.getFullYear() + "-" + (date.getMonth() + 1)
        }else if (photoOrg.history.historyState.so) {
            let date = new Date(albumModel.createDate);
            presentMonth = date.getFullYear() + "-" + (date.getMonth() + 1)
        }
        /*try{
            document.getElementById("loadingBar").style.display = "none";
        }catch(e){}*/
        
        photoOrg.photoLib.albumModelList[albumModel.id] = albumModel;
        const context = {
            id: albumModel.id,
            version: albumModel.version,
            aId: albumModel.aId,
            count: imagesCount,
            albumImgUrl: albumModel.albumImgUrl,
            content: content,
            imagesCount: imagesCount,
            dontShowImagesCount: albumModel.dontShowImagesCount,
            imageText: imageText,
            caption: albumModel.caption,
            description: albumModel.description,
            o_caption: albumModel.o_caption,
            accessType: accessType,
            likesCount: albumModel.likesCount,
            friendsCount: albumModel.friendsCount,
            shared: albumModel.friendsCount > 0,
            sharedByMe: sharedByMe,
            ownerName: ownerName,
            sharedWithName: sharedWithName,
            shareIcon: shareIcon,
            sharedWithAllNames: sharedWithAllNames,
            albumSelected: albumSelected,//Album selected is used in library and used as default selected in picker.
            albumSelectedInPicker: albumSelectedInPicker,
            pageNo: pageNo,
            presentMonth: presentMonth,
            isShared: albumModel.isShared,
            albumSource: albumModel.source,//To show the source of the image like google, fb etc.,
            displayShareIcon: (albumModel.source == "google" || albumModel.type == "received") ? "none": "",
            isReceived: albumModel.type == "received" ? true : false,
            inlineIngestionFlow:inlineIngestionFlow,
            isGoogleAlbum: photoOrg.history.historyState.st == photoOrg.constants.GOOGLE_VIEW
        };
        if (photoOrg.photoLib.albumModelList[albumModel.id].systemTags && photoOrg.assetUtils.getValue(albumModel.systemTags, 'isFavorite') == "true") {
            context.caption = photoOrg.translations.photos["sub_header"]["favorite_alb"];
        }
        //By default Setting the host source icon on host albums as assetSource will not be present in assets response in inline ingestion view
        if(photoOrg.aggSdkUtils.isTabbedView()){
            context.albumSource = context.albumSource ? context.albumSource : photoOrg.constants.SOURCE_HOST;
        }

        const onKeyDownHandlerAlbum = e => {
            if (e.keyCode === 13) {
                loadSingleAlbum(e);
            }
          };
        
    return (
            <div onKeyDown={onKeyDownHandlerAlbum} ref={ref} className="album-item observerable-div-rc" aid={context.id} aria-label={photoOrg.Util.getAltMessageFormat(context.caption)} tabIndex="0" role="button" onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut} onFocus={showAlbumHoverSection}>
                <div className="text-center item-sec-div" aid={context.id} id={`section_"${context.id}`} sqatud={`album_${context.id}`} version={context.version} imgcount={context.count} pageno={context.pageNo} presentmonth={context.presentMonth}>
                    <div className="storyImage selectable-asset" id={context.id} role='button' aria-label={photoOrg.Util.getAltMessageFormat(context.caption)}>
                        <Tappable onTap={loadSingleAlbum}>
                            <div className="album-item-wrapper library-item">
                                <div className="photoOrgStory">
                                    <figure style={{ 'backgroundImage': `url(${context.albumImgUrl})` }}>
                                        <img alt="size-placeholder" className="size-placeholder" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABdJREFUeNpi/P//PwMyYGJAA4QFAAIMAMaOAwX2faROAAAAAElFTkSuQmCC" />
                                    </figure>
                                </div>
                                <div className="selection-border"></div>
                            </div>
                        </Tappable>
                        <div className="story-caption-area">
                            {(photoOrg.photoLib.config.loadAsPhotoPicker && context.albumSelected) ?
                                <Tappable onTap={loadSingleAlbum}>
                                    <span className="default-selected-txt">
                                        <span className="default-desktop-txt">{photoOrg.translations.photos["action_container"]["album_already_in_project"]}</span>
                                        <span className="default-mobile-txt">{photoOrg.translations.photos["action_container"]["already_only_project"]}</span>
                                    </span>
                                </Tappable>
                                : ""}
                            <Tappable onTap={loadSingleAlbum}><div id={context.id} className={`loadSingleAlbumView ${isHovering? "menu_active" : ""}`}></div></Tappable>
                            <div className="story-txt-bottom">

                            <div>
                                {(!photoOrg.photoLib.config.loadAsPhotoPicker) ?
                                   
                                    (<ul className="iconspallet" ref={menuRef} role="menubar" style={{visibility: isHovering? "visible" : "hidden"}} onKeyDown={handleAlbumOptionAccessibility} aria-label={photoOrg.translations.photos["aria_label"]["album_options"]} tabIndex='-1' aria-activedescendant={`album_${context.id}`}>
                                        <li className="libsettingsic" name="av_settings" role="none">
                                            <a role="menuitem" href ='#' ref={(el) => {settingsIconRef.current=el; menuItemsRef.current[0] = el;}} onClick={handleDropdownClick} onTouchStart={handleDropdownClick} id={`album_${context.id}`}
                                                className={`newdropdown icon-icon_options_small album${context.id}`}
                                                aria-label={photoOrg.translations.photos["action_container"]["tools_txt"]}
                                                title={photoOrg.translations.photos["action_container"]["tools_txt"]}
                                                aria-haspopup="true"
                                                tabIndex='-1'
                                                aria-controls="ralb-gearicon" data-custom-dropdown="true" aria-expanded="false" >
                                            </a>
                                        </li>
                                        {(!context.inlineIngestionFlow && !context.isGoogleAlbum) ?
                                            <li className={`${(context.accessType == photoOrg.photoLib.accessType.sharedWithMe) ? "friends-album-share" : "album-share"} `} style={{ display: context.displayShareIcon }} onClick={albumOptionsEvents.shareAlbum} onTouchStart={albumOptionsEvents.shareAlbum} role="none">
                                                <a className="icon-icon_share_photo album-share-ic"
                                                    role="menuitem"
                                                    ref={(el) => (menuItemsRef.current[1] = el)}
                                                    id={`album_share${context.id}`}
                                                    tabIndex='-1'
                                                    aria-label={`${photoOrg.translations.photos["share_album"]}${photoOrg.translations.photos["aria_label"]["opens_dialog"]}`}
                                                    title={photoOrg.translations.photos["share_album"]} href ='#' onClick={(e) => {e.preventDefault()}}>
                                                </a>
                                            </li>
                                            : ""}
                                        <li className="libprintsic" name="av_print_album" onClick={redirectTOPrints} onTouchStart={redirectTOPrints} role="none">
                                            <a href ='#' onClick={(e) => {e.preventDefault()}}
                                                role="menuitem"
                                                ref={(el) => (menuItemsRef.current[2] = el)}
                                                tabIndex='-1'
                                                id={`album_print${context.id}`}
                                                aria-label={photoOrg.translations.photos["product_details"]["order_prints_tip"]}
                                                title={photoOrg.translations.photos["product_details"]["order_prints_tip"]}>
                                                <span className="icon-link-prints-share"></span>
                                            </a>
                                        </li>

                                        <li className="selectAlbum" id={`selectAlbum_${context.id}`} name="av_select_album" role='none'>
                                            <a href ="#" onClick={(event) =>{selectOrDeselectAlbum(event, context.albumSelected)}}
                                                onTouchEnd={(event) =>{selectOrDeselectAlbum(event, context.albumSelected)}}
                                                ref={(el) => (menuItemsRef.current[3] = el)}
                                                tabIndex='-1'
                                                id={`album_select${context.id}`}
                                                aria-label={(context.albumSelected) ? `${photoOrg.translations.photos["album_unselect_all"]} ${context.o_caption}. ${photoOrg.translations.photos["album_unselect_all_2"]}` : `${photoOrg.translations.photos["album_select_all"]} ${context.o_caption}.` }
                                                className={`${context.id} selectAllAblum ${(context.albumSelected) ? "alb_selected" : ""} icon-icon_checkmark_circle`}  role='menuitemcheckbox' aria-checked={(context.albumSelected) ? "true" : "false"} >
                                            </a>
                                        </li>
                                    </ul>)
                                    :
                                    (<ul className="iconspallet" ref={menuRef}  style={{visibility: isHovering? "visible" : "hidden"}} role="menubar" tabIndex='-1' aria-label={photoOrg.translations.photos["aria_label"]["album_options"]} aria-activedescendant={`album_select${context.id}`}>
                                        <li className="selectAlbum" id={`selectAlbum_${context.id}`}
                                            aria-label={(context.albumSelected || context.albumSelectedInPicker) ? photoOrg.translations.photos["album_unselect_all"] : photoOrg.translations.photos["album_select_all"]} 
                                            name="av_select_album" role="none">
                                            <a href ='#' ref={(el) => (menuItemsRef.current[0] = el)} id={`album_select${context.id}`} tabIndex='-1' onClick={(event) =>{selectOrDeselectAlbum(event, (context.albumSelected || context.albumSelectedInPicker))}}  onTouchStart={(event) =>{selectOrDeselectAlbum(event, (context.albumSelected || context.albumSelectedInPicker))}} className={`${context.id} selectAllAblum ${(context.albumSelected || context.albumSelectedInPicker) ? "alb_selected" : ""} icon-icon_checkmark_circle`} role='menuitemcheckbox' aria-checked={(context.albumSelected) ? "true" : "false"}>
                                            </a>
                                        </li>
                                    </ul>)
                                    }
                               </div>     
                            </div>

                        </div>
                    </div>
                    <Tappable onTap={loadSingleAlbum}>
                        <div className="story-anchor" style={{ "-webkit-user-select": "none", "-webkit-touch-callout": "none" }}>
                            <p className="storyCaption" role="link" tabindex="0" title={context.o_caption } o_caption={context.o_caption }>{context.o_caption }</p>
                            {(context.accessType != photoOrg.photoLib.accessType.sharedWithMe && context.accessType != photoOrg.photoLib.accessType.myShared && !context.dontShowImagesCount)?
                                <span className="storyDescription">
                                {(context.isShared || context.isReceived)?(
                                    <><span className="image-count">{context.imagesCount}</span><span className="image-text">{context.imageText}</span></>
                                    ):( <>
                                        {context.content}
                                    </>
                                    )}
                                    <>
                                    {(context.isShared) ?(<>
                                        <span className="story-share">.</span>
                                        <span>{photoOrg.translations.photos["asset_text"]["is_shared_album"]}</span></>):""}
                                        {(context.isReceived) ?(<>
                                        <span className="story-share">.</span>
                                        <span>{photoOrg.translations.photos["asset_text"]["shared_with_me"]}</span></>):""}
                                    </>
                                </span>
                                :""}
                                {(context.shared && context.ownerName) ?(
                                    <p className="share-info" x="y" title={`${(context.sharedByMe) ? context.sharedWithAllNames : ""}`}>
                                        {(context.sharedByMe) ?
                                            (<><span> {photoOrg.translations.photos["with"]}</span> <span className="share-name">{context.sharedWithName}</span> <span>{(context.friendsCount > 1) ? `+ ${context.friendsCount - 1}` : ""}</span></>) 

                                        : (<><span>{photoOrg.translations.photos["by"]}</span><span className="share-name">{context.ownerName}</span></>)
                                        }
                                    </p>
                                ):""}
                        </div>
                        <div className={`album-select-confirm-label ${context.id}_album-select-confirm-label`}>{photoOrg.translations.photos["entire_album_selected"]}</div><div className={`album-select-confirm-label ${context.id}_no_photos_label`}>
                            {photoOrg.translations.photos["no_photos_in_album"]}
                        </div>   
                    </Tappable>     
                </div>
            </div>)   
    }
    catch (e) {
        photoOrg.clientLogger.error({description: "LIBRARY:albums_view:PrepareIndividualAlbum:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
    }
}

PrepareIndividualAlbum.propTypes = {
    albumModel: PropTypes.shape({
        accountId: PropTypes.number,
        albumId: PropTypes.string,
        assetIdList: PropTypes.array,
        createDate: PropTypes.number,
        firstAssetId: PropTypes.object,
        imagesCount: PropTypes.number,
        name: PropTypes.string,
        ownerAccountId: PropTypes.number,
        systemTags: PropTypes.array,
        url: PropTypes.string,
        userTags: PropTypes.array,
        version: PropTypes.number,
        dontShowImagesCount: PropTypes.bool,
        assetType: PropTypes.string,
        caption: PropTypes.string,
        description: PropTypes.string,
        albumImgUrl: PropTypes.string,
        isShared: PropTypes.bool,
        id: PropTypes.string
    }),
    accessType: PropTypes.string,
    foundRef: PropTypes.bool,
    setRef: PropTypes.func,
    container_key: PropTypes.string,
    albumThumnailSize: PropTypes.number,
    inlineIngestionFlow: PropTypes.bool
}

export default PrepareIndividualAlbum;
